(function() { window.GUID_2a0fa479_83b0_46ba_8c1b_4828e3e81a2e = { getGuid: function() { return "2a0fa479-83b0-46ba-8c1b-4828e3e81a2e"; } }; })();
var CS;
(function (CS) {
    var Entity;
    (function (Entity) {
        var General;
        (function (General) {
            let ImageHistoryTypeEnum;
            (function (ImageHistoryTypeEnum) {
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Person"] = 0] = "Person";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["HomePage"] = 1] = "HomePage";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["ImageDynamicDisplay"] = 2] = "ImageDynamicDisplay";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Place"] = 3] = "Place";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Publicity"] = 4] = "Publicity";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["SportEvent"] = 5] = "SportEvent";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Team"] = 6] = "Team";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["ProfilPicture"] = 7] = "ProfilPicture";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["FacebookShare"] = 8] = "FacebookShare";
            })(ImageHistoryTypeEnum = General.ImageHistoryTypeEnum || (General.ImageHistoryTypeEnum = {}));
        })(General = Entity.General || (Entity.General = {}));
    })(Entity = CS.Entity || (CS.Entity = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ImageHistoryTypeEnum.pre.js.map
